import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell } from 'components/HonestTable/HonestTable.styled'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Pagination } from 'components/Pagination/Pagination'
import { clearPermitTypes, getPermitTypes } from 'features/operations/permitsSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { Button, Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { BodyText } from 'styling/Typography'
import { IGetAllPermitTypesSingleResponse } from 'types/api/operationsPermitsApi.interface'
import { getParams, handlePagination } from 'utils/helpers'

const columns: IHonestTableColumn<IGetAllPermitTypesSingleResponse>[] = [
    {
        id: 'code',
        header: 'Code',
        sortable: true,
        sticky: true,
        minWidth: '10rem',
        cell: (item) => (
            <Cell>
                <BodyText weight='600'>{item.code}</BodyText>
            </Cell>
        ),
    },
    {
        id: 'name',
        header: 'Name',
        sortable: true,
        minWidth: '14rem',
        cell: (item) => <BodyText>{item.name}</BodyText>,
    },
    {
        id: 'minHolders',
        header: 'Min holders',
        minWidth: '10rem',
        cell: (item) => <BodyText>{item.minHolders}</BodyText>,
    },
    {
        id: 'coPresence',
        header: 'Co-presence',
        minWidth: '10rem',
        cell: (item) => <BodyText>{item.requiresCoPresence ? 'Yes' : 'No'}</BodyText>,
    },
    {
        id: 'capabilities',
        header: 'Capabilities',
        fill: true,
        cell: (item) => (
            <BodyText>
                {item.requiredCapabilities?.length
                    ? item.requiredCapabilities.map((c) => c.name).join(', ')
                    : '-'}
            </BodyText>
        ),
    },
]

export const PermitTypes = () => {
    const navigate = useNavigate()
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const { data, totalPages } = useSelector((state: RootState) => state.permits.permitTypes)

    useQueryPagination({
        fetchFunctions: [getPermitTypes],
        cleanUpFunctions: [clearPermitTypes],
        params,
    })

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between width='100%' mb='16'>
                    <H1WithBack arrow title='Permit types' />
                    <Button orange onClick={() => navigate('add')}>
                        Add type
                    </Button>
                </Flex>
                {data?.length ? (
                    <HonestTable
                        columns={columns}
                        data={data}
                        keyField='id'
                        onClick={(item) => navigate(`${item.id}`)}
                    />
                ) : (
                    <NoData text='No permit types to display' />
                )}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
